import { JIRA } from "./addTestCaseToJira.fields";

const FORM_CONFIG = {
    [JIRA.id]: JIRA,
  };
  
  export default FORM_CONFIG;